import { RouterProvider } from "react-router-dom";
import { Toaster } from "sonner";
import { ErrorBoundary } from "@/components/ui/error-boundary";
import { router } from "@/routes";

export default function App() {
	return (
		<ErrorBoundary>
			<RouterProvider router={router} />
			<Toaster position="top-right" richColors closeButton />
		</ErrorBoundary>
	);
}
